import { AssuranceTypes } from './types'
import { SAVE_ASSURANCE } from './actionTypes'
import { AssuranceModalModel } from '../../../types/assurance/assuranceModalModel'

const initialState: AssuranceModalModel = {
	assuranceFinie: false,
	finAssuranceProche: false
}

const assurance = (
	state: AssuranceModalModel = initialState,
	action: AssuranceTypes
): AssuranceModalModel => {
	switch (action.type) {
		case SAVE_ASSURANCE: {
			return 'payload' in action ? action.payload : initialState
		}
		default:
			return state
	}
}

export default assurance